import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

export const deleteSnapshotPermission = ({
  userId,
  snapshotId,
}: {
  userId: number;
  snapshotId: number;
}) => {
  return axios.delete(
    `/api/users/${userId}/snapshot/${snapshotId}/permissions`
  );
};

type UseDeleteSnapshotPermissionOptions = {
  userId: number;
  config?: MutationConfig<typeof deleteSnapshotPermission>;
};

export const useDeleteSnapshotPermission = ({
  userId,
  config,
}: UseDeleteSnapshotPermissionOptions) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['user', userId]);
    },
    ...config,
    mutationFn: deleteSnapshotPermission,
  });
};
